import { render, staticRenderFns } from "./ProductDropdownOption.vue?vue&type=template&id=fdcda796"
import script from "./ProductDropdownOption.vue?vue&type=script&lang=js"
export * from "./ProductDropdownOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdcda796')) {
      api.createRecord('fdcda796', component.options)
    } else {
      api.reload('fdcda796', component.options)
    }
    module.hot.accept("./ProductDropdownOption.vue?vue&type=template&id=fdcda796", function () {
      api.rerender('fdcda796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductDropdownOption.vue"
export default component.exports